import React from 'react';
import './AutoSaveIndicator.css';

const AutoSaveIndicator = ({ 
  saveStatus, 
  lastSaved, 
  isOnline, 
  hasOfflineDrafts,
  isSyncInProgress,
  onManualSave,
  className = '' 
}) => {
  const formatLastSaved = (date) => {
    if (!date) return '';
    
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    
    if (minutes > 0) {
      return `${minutes}m ago`;
    } else if (seconds > 30) {
      return `${seconds}s ago`;
    } else {
      return 'just now';
    }
  };

  const getStatusIcon = () => {
    switch (saveStatus) {
      case 'saving':
        return '⏳';
      case 'saved':
        return '✅';
      case 'error':
        return '❌';
      case 'offline':
        return '📱';
      default:
        return '⚪';
    }
  };

  const getStatusText = () => {
    switch (saveStatus) {
      case 'saving':
        return 'Saving...';
      case 'saved':
        return `Saved ${formatLastSaved(lastSaved)}`;
      case 'error':
        return 'Save failed';
      case 'offline':
        return 'Saved offline';
      default:
        return 'Unsaved changes';
    }
  };

  const getStatusClass = () => {
    switch (saveStatus) {
      case 'saving':
        return 'autosave-saving';
      case 'saved':
        return 'autosave-saved';
      case 'error':
        return 'autosave-error';
      case 'offline':
        return 'autosave-offline';
      default:
        return 'autosave-unsaved';
    }
  };

  return (
    <div className={`autosave-indicator ${getStatusClass()} ${className}`}>
      <div className="autosave-status">
        <span className="autosave-icon">{getStatusIcon()}</span>
        <span className="autosave-text">{getStatusText()}</span>
      </div>
      
      {!isOnline && (
        <div className="autosave-offline-notice">
          <span className="offline-icon">📡</span>
          <span>Working offline</span>
        </div>
      )}
      
      {hasOfflineDrafts && isOnline && isSyncInProgress && (
        <div className="autosave-sync-notice">
          <span className="sync-icon">🔄</span>
          <span>Syncing offline changes...</span>
        </div>
      )}
      
      {hasOfflineDrafts && isOnline && !isSyncInProgress && (
        <div className="autosave-sync-notice">
          <span className="sync-icon">⏳</span>
          <span>Offline changes pending sync</span>
        </div>
      )}
      
      {saveStatus === 'error' && onManualSave && (
        <button 
          className="autosave-retry-btn"
          onClick={onManualSave}
          title="Retry save"
        >
          🔄 Retry
        </button>
      )}
    </div>
  );
};

export default AutoSaveIndicator;
